import React from 'react';
import PropTypes from 'prop-types';
import useCurrentPositionAndTime from 'hooks/useCurrentPositionAndTime';

import Style from './EPGCurrentTimer.module.scss';

const CurrentTimer = props => {
  const { ended, startingTs, totalMinutes } = props;
  const { currentPosition, currentTime } = useCurrentPositionAndTime({
    totalMinutes,
    startingTs,
    ended,
  });

  const leftStyle = { left: `${currentPosition}%` };

  return (
    <div className={Style.currentTimerContainer}>
      <div style={leftStyle} className={Style.currentTimerTime}>
        {currentTime}
      </div>
      <div style={leftStyle} className={Style.currentTimerArrow} />
      <div style={leftStyle} className={Style.currentTimer} />
    </div>
  );
};

CurrentTimer.propTypes = {
  ended: PropTypes.func,
  startingTs: PropTypes.number.isRequired,
  totalMinutes: PropTypes.number.isRequired,
};

export default CurrentTimer;
